import { apiClient } from './client';

export const clinicApi = {
  getAll: (params) => apiClient.get('/clinics', { params }),
  getById: (id) => apiClient.get(`/clinics/${id}`),
  getActive: () => apiClient.get('/clinics/active'),
  create: (data) => apiClient.post('/clinics', data),
  update: (id, data) => apiClient.put(`/clinics/${id}`, data),
  delete: (id) => apiClient.delete(`/clinics/${id}`),
};
